import React, { useEffect, useState } from "react";
import styles from "../RequestForQuotePage/index.module.css";


const WishlistImages = ({ imageUrls , id }) => {


    return (
        <div id={id} className="wishlist--images">
            {imageUrls.map((url, index) => (
                index < 3 ? 
                <div id={id} className={"wishtlist--img-item "+styles.productimg}>
                    <img id={id} src={url} alt="watch" />
                </div>
                : ''
            ))}
        </div>
    );
}
export default WishlistImages;

{/* <tr>
        <td className="gf--compare--details">
            <div>
                <h4>Available Option</h4>
                <h4>Vendor</h4>
                <h4>SKU</h4>
                <h4>Type</h4>
                <h4>Available Option</h4>
            </div>
        </td>
        {
            Object.keys(selectedCheckbox).map((key) =>
                getWishlistproduct.map((item) =>
                    item.var_id == key ?
                        <>
                            <td className="gf--compareProduct">
                                <div>
                                    <h4>{item.quantity > 0 ? "Yes" : 'No'}</h4>
                                    <h4>{item.vendor != '' ? item.vendor : '-'}</h4>
                                    <h4>{item.sku != '' ? item.sku : '-'}</h4>
                                    <h4>{item.productType != '' ? item.productType : '-'}</h4>
                                    <h4>{item.totalVariants != '' ? item.totalVariants : '-'}</h4>
                                </div>
                            </td>
                        </>
                        : ''
                )
            )
        }
</tr> */}